import {apolloClient} from '@/plugins/apollo';

export const handleGqlResponseBody = async (cb) => {
	const callbackResponse = cb({
		query: (options) => {
			return {
				options,
				query: apolloClient.query(options)
			};
		},
		mutation: (options) => {
			return {
				options,
				mutation: apolloClient.mutate(options)
			};
		}
	});
	
	if (callbackResponse.query) {
		const response = await callbackResponse.query;
		const data = Object.keys(response.data);
		if (data.length === 1) return response.data[data[0]];
		return data.map(d => response.data[d]);
	} else if (callbackResponse.mutation) {
		const response = await callbackResponse.mutation;
		const data = Object.keys(response.data);
		if (data.length === 1) return response.data[data[0]];
		return data.map(d => response.data[d]);
	}
	
	return null;
};
